/**
 * @description Alert 弹窗信息
 * @param {String/Node} content  文本内容
 * @param {String} oKBtnTxt   确认按钮文本 默认值'确定'
 * @param {String} cancelBtnTxt   取消按钮文本 默认值'取消'
 * @param {Boolean} hideCancelBtn   隐藏取消按钮 默认值false
 * @param {Boolean} hideOkBtn  隐藏ok按钮 默认值false
 * @param {Boolean} onClickOK   弹窗类型 info
 * @param {Boolean} hasCloseBtn  右上角是否有关闭按钮，默认false
 * @param {Boolean} hasCloseBtn  右上角是否有关闭按钮，默认false
 * @param {Boolean} title  弹窗标题，默认""
 * @param {Boolean} onSuccess  点击ok以后触发的事件，默认null
 */
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import "./dialog.less";
import {getCurrentLang} from "../../../config/commonUtil.js"
import { createRoot } from 'react-dom/client';

let div = document.getElementById("aia-bx-tool-box");
if (div === null) {
  div = document.createElement("div");
  div.setAttribute("id", "aia-bx-tool-box");
  document.body.appendChild(div);
}

function notice(args) {
  const root = createRoot(div);
  return root.render(<Dialog {...args} />);
  //return ReactDOM.render(<Dialog {...args} />, div);
}

function Dialog(props) {
  const { t } = useTranslation();
  const [msgs, setMsgs] = useState([]);
  const lang = getCurrentLang();

  const {
    hasCloseBtn,
    content,
    title,
    cancelBtnTxt,
    oKBtnTxt,
    hideCancelBtn,
    onSuccess,
    hideOkBtn,
    // hideRetryBtn
  } = props;

  useEffect(() => {
    setMsgs([props]);
  }, [props]);

  const destoryDialog = () => {
    setMsgs([]);
  };

  const sureDialog = () => {
    setMsgs([]);
    onSuccess && onSuccess();
  };
  // const refreshNow = () => {
  //   window.location.href = `/${lang}/home`;  
  //   setMsgs([]);  
  // };

  return (
    <div>
      {msgs.length > 0 && (
        <div className="aia-bx-dialog aia-bx-fix-layer">
          <div className="aia-bx-dialog-content aia-bx-center bg-white pd-15">
            <div className="aia-bx-dialog-top">
              {title && (
                <div className="aia-bx-default-headline-M aia-bx-color-darkblue aia-bx-modal-title">
                  {title}
                </div>
              )}
              {/* 关闭按钮 */}
              {hasCloseBtn && (
                <div
                  onClick={destoryDialog}
                  className="aia-bx-default-headline-S aia-bx-color-darkblue aia-bx-dialog-close"
                >
                  X
                </div>
              )}
            </div>
            {content && (
              <div className="aia-bx-dialog-incontent">
                {typeof content === "function" ? content(sureDialog) : content}
              </div>
            )}
            <div className="aia-bx-flex aia-bx-flex-jcc aia-bx-dialog-btns">
              {!hideCancelBtn && (
                <span
                  onClick={destoryDialog}
                  className="aia-bx-button aia-bx-dialog-btns-l"
                >
                  {!cancelBtnTxt ? t("common:cancelBtn") : cancelBtnTxt}
                </span>
              )}
              {/* {hideRetryBtn && (
                <span
                  onClick={refreshNow}
                  className="aia-bx-button aia-bx-dialog-btns-l"
                >
                  {t("errorMsg.retryBtn")}
                </span>
              )} */}
              {/* 是否隐藏ok按钮 */}
              {!hideOkBtn && (
                <span
                  onClick={sureDialog}
                  className="aia-bx-button button-primary"
                >
                  {!oKBtnTxt ? t("common:okBtn") : oKBtnTxt}
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

let DialogApi = (objData) => {
  const title = objData.title || "";
  const content = objData.content || "";
  const oKBtnTxt = objData.oKBtnTxt || "";
  const cancelBtnTxt = objData.cancelBtnTxt || "";
  const hideCancelBtn = objData.hideCancelBtn || false;
  const onSuccess = objData.onSuccess || null;
  const hasCloseBtn = objData.hasCloseBtn || false;
  const hideOkBtn = objData.hideOkBtn || false;
  const hideRetryBtn = objData.hideRetryBtn || true;
  return notice({
    title,
    content,
    oKBtnTxt,
    cancelBtnTxt,
    hideCancelBtn,
    onSuccess,
    hasCloseBtn,
    hideOkBtn,
    hideRetryBtn,
  });
};

export default DialogApi;
